import { IoSearch } from "react-icons/io5";
import styled from "styled-components";

export default styled.input.attrs(
    ({ onChange: _onChange, onKeyDown: _onKeyDown }) => (
        {
            onChange: (event) => _onChange(event.target.value),
            // never implicitly submit an enclosing <form>
            onKeyDown: (event) => {
                if (event.key === "Enter") event.preventDefault();
                _onKeyDown?.(event);
            },
            type: "text",
        }
    )
)`
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    box-sizing: border-box;
    font-family: var(--font-mono), monospace;
    font-size: 3.2em;
    flex: auto;
    margin: 0;
    outline: none;
    padding: 0 1em 0 0;

    &:focus {
        //border-bottom-color: #2e58b0;
    }
`;

// "button", not "reset": clears via onClick, must not reset an enclosing <form>
export const HeroInputReset = styled.button.attrs({ type: "button" })`
    align-items: center;
    background: transparent;
    border: none;
    color: #0007;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 2em;
    padding: 0;
    transition: 200ms;

    &:hover {
        color: #000;
    }
`;

export const HeroInputField2 = styled.div`
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: row;
    position: relative;

    input {
        width: 100%;
    }

    input:placeholder-shown + ${ HeroInputReset } {
        display: none;
    }

    input + ${ HeroInputReset } {
        position: absolute;
        right: .3em;
    }
`;

export const HeroInputIcon = styled(IoSearch)`
    color: #0000000a;
    height: 8em;
    left: -1.6em;
    pointer-events: none;
    position: absolute;
    top: -1.5em;
    width: auto;
`;
